module.exports = __webpack_public_path__ + "static/media/Lotto6.b6a0b4db.jpg";